<template>
  <DetailTemplate
    :customClass="'adjustment-detail detail-page'"
    v-if="getPermission('adjustment:view')"
  >
    <template v-slot:header-title>
      <div class="d-flex">
        <template v-if="pageLoading">
          <v-skeleton-loader
            class="custom-skeleton height-40px custom-skeleton-full-width"
            width="600"
            type="text"
          >
          </v-skeleton-loader>
        </template>
        <template v-else>
          <h1
            class="form-title custom-nowrap-ellipsis text-capitalize mb-0 mr-2"
          >
            {{ detail.name }}
          </h1>
          <v-chip
            label
            color="chip-custom-blue"
            outlined
            class="text-white p-3"
            style="font-size: 21px !important; font-weight: 700"
            >{{ detail.barcode }}</v-chip
          >
        </template>
      </div>
    </template>
    <template v-slot:header-action>
      <template v-if="getPermission('product:update')">
        <v-skeleton-loader
          class="custom-skeleton d-inline-block"
          v-if="pageLoading"
          type="button"
        >
        </v-skeleton-loader>
        <v-menu
          v-else
          transition="slide-y-transition"
          bottom
          content-class="custom-menu-list"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <!--  <v-btn
              :disabled="!formValid || formLoading || pageLoading"
              :loading="formLoading"
              class="mx-2 custom-bold-button white--text"
              color="cyan"
              v-bind="attrs"
              v-on="on"
            >
              More... <v-icon right>mdi-chevron-down</v-icon>
            </v-btn> -->
          </template>
          <v-list>
            <template v-for="(more, index) in productMoreAction">
              <v-list-item
                link
                v-on:click="updateMoreAction(more.action)"
                :key="index"
                :disabled="more.disabled"
              >
                <v-list-item-icon class="margin-auto-zero mr-3 my-2">
                  <v-icon class="icon-default-blue">{{ more.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title class="font-weight-500 font-size-14">{{
                  more.title
                }}</v-list-item-title>
              </v-list-item>
            </template>
          </v-list>
        </v-menu>
      </template>
      <template v-if="getPermission('product:update')">
        <!-- <v-btn
          :disabled="!formValid || formLoading || pageLoading"
          class="mx-2 custom-bold-button white--text"
          color="cyan"
          :to="
            getDefaultRoute('product.update', {
              param: { id: product },
            })
          "
        >
          <v-icon small left>mdi-pencil</v-icon>
          Edit
        </v-btn> -->
      </template>
      <v-btn
        depressed
        class="mx-2 custom-grey-border custom-bold-button"
        v-on:click="goBack"
      >
        <v-icon small left>mdi-keyboard-backspace</v-icon>
        Back
      </v-btn>
    </template>
    <template v-slot:body>
      <v-container fluid>
        <v-tabs
          v-model="productTab"
          background-color="transparent"
          color="cyan"
          class="custom-tab-transparent"
        >
          <template v-for="(tab, index) in tabs">
            <v-tab
              v-if="getPermission(tab.permission + ':view')"
              class="font-size-16 font-weight-600 px-8"
              :key="index"
              :href="'#' + tab.key"
              :disabled="tab.disabled"
            >
              <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
                <!--begin::Svg Icon-->
                <inline-svg
                  :src="$assetURL('media/custom-svg/' + tab.key + '.svg')"
                />
                <!--end::Svg Icon-->
              </span>
              {{ tab.title }}
              <!-- <span v-if="tab.title == 'Supplier'">
                ({{
                  detail.supplier_data ? detail.supplier_data.length : 0
                }})
              </span> -->
              <span v-if="tab.title == 'Product'">
                ({{ detail.line_items ? detail.line_items.length : 0 }})
              </span>
            </v-tab>
          </template>
        </v-tabs>
        <v-tabs-items v-model="productTab">
          <v-tab-item
            v-if="getPermission('adjustment:view')"
            :value="'overview'"
          >
            <Overview :detail="detail"></Overview>
          </v-tab-item>
          <v-tab-item v-if="getPermission('adjustment:view')" value="supplier">
            <ProductSpplierListing
              type="supplier"
              :product="detail.supplier_data"
              v-if="detail.id"
              @success="getProductDetail()"
            ></ProductSpplierListing>
          </v-tab-item>

          <v-tab-item v-if="getPermission('product:view')" value="product">
            <ProductPriceListing
              type="product"
              :price-data="detail.line_items"
              :product="detail.id"
              @success="getProductDetail()"
            ></ProductPriceListing>
          </v-tab-item>
          <v-tab-item
            v-if="getPermission('adjustment:view')"
            :value="'attachment'"
          >
            <div class="service-detail-height">
              <Images
                :images="detail.adjustment_images"
                :parent="detail.id"
                type="addjustment"
                :isPageLoading="pageLoading"
              ></Images>
            </div>
          </v-tab-item>

          <v-tab-item
            v-if="getPermission('product:view')"
            :value="'attachments'"
          >
            <div class="service-detail-height">
              <FileTemplate
                :attachments="detail.product_attachments"
              ></FileTemplate>
            </div>
          </v-tab-item>
          <v-tab-item v-if="getPermission('warranty:view')" :value="'warranty'">
            <div class="service-detail-search-height">
              <Warranty :detail="detail"></Warranty>
            </div>
          </v-tab-item>
          <v-tab-item v-if="getPermission('job:view')" :value="'job'">
            <div class="service-detail-search-height">
              <Tickets :detail="detail" type="product"></Tickets>
            </div>
          </v-tab-item>
          <v-tab-item
            v-if="getPermission('quotation:view')"
            :value="'quotation'"
          >
            <div class="service-detail-search-height">
              <Quotations :detail="detail" type="product"></Quotations>
            </div>
          </v-tab-item>
          <v-tab-item v-if="getPermission('invoice:view')" :value="'invoice'">
            <div class="service-detail-search-height">
              <Invoices :detail="detail" type="product"></Invoices>
            </div>
          </v-tab-item>
          <v-tab-item
            v-if="getPermission('product-adjustment:view')"
            :value="'product-adjustment'"
          >
            <div class="service-detail-search-height">
              <ProductAdjustment :detail="detail"></ProductAdjustment>
            </div>
          </v-tab-item>
          <v-tab-item  :value="'history'">
            <div class="service-detail-search-height">
              <InternalHistoryDetail
                type="adjustment"
                :type_id="detail.id"
              ></InternalHistoryDetail>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-container>
    </template>
  </DetailTemplate>
</template>

<script>
import DetailTemplate from "@/view/pages/partials/Detail-Template.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { GET, PATCH } from "@/core/services/store/request.module";
import Overview from "@/view/pages/product/detail/adjustmentOverview";
import ProductPriceListing from "@/view/pages/product/detail/adjustmentListing";
import ProductSpplierListing from "@/view/pages/product/detail/AdjustmentSpplierListing";
import Warranty from "@/view/pages/product/detail/Warranty";
import Tickets from "@/view/pages/partials/Detail/Tickets";
import Quotations from "@/view/pages/partials/Detail/Quotation";
import Invoices from "@/view/pages/partials/Detail/Invoice";
import ProductAdjustment from "@/view/pages/product/detail/ProductAdjustment";
import Images from "@/view/pages/partials/Detail/adjustmenetImage";
import InternalHistoryDetail from "@/view/pages/partials/Detail/Internal-History-Detail.vue";
import FileTemplate from "@/view/pages/partials/FileTemplate.vue";

export default {
  data() {
    return {
      detail: new Object(),
      productMoreAction: [
        /*{
          title: "Convert to Equipment",
          action: "convert_to_equipment",
          icon: "mdi-power-plug-outline",
          disabled: false,
        },*/
        {
          title: "Duplicate",
          action: "duplicate",
          icon: "mdi-content-duplicate",
          disabled: false,
        },
        {
          title: "Generate Adjustment",
          action: "generate_adjustment",
          icon: "mdi-content-duplicate",
          disabled: false,
        },
        {
          title: "Mark as Active",
          action: "mark_as_active",
          icon: "mdi-check-all",
          disabled: false,
        },
        {
          title: "Mark as In-Active",
          action: "mark_as_inactive",
          icon: "mdi-check-all",
          disabled: false,
        },
      ],
      tabs: [
        {
          title: "Overview",
          icon: "mdi-phone",
          key: "overview",
          permission: "adjustment",
          disabled: false,
        },
        /*{
          title: "Adjustment",
          icon: "mdi-account-multiple",
          key: "product-adjustment",
          permission: "product-adjustment",
          disabled: false,
        },*/
        /* {
          title: "Supplier",
          icon: "mdi-phone",
          key: "supplier",
          permission: "product",
          disabled: false,
        }, */
        {
          title: "Product",
          icon: "mdi-phone",
          key: "product",
          permission: "product",
          disabled: false,
        },
        {
          title: "Attachment",
          icon: "mdi-phone",
          key: "attachment",
          permission: "product",
          disabled: false,
        },

        /*  {
          title: "Attachments",
          icon: "mdi-phone",
          key: "attachments",
          permission: "product",
          disabled: false,
        }, */
        /* {
          title: "Warranty",
          icon: "mdi-credit-card",
          key: "warranty",
          permission: "warranty",
          disabled: false,
        }, */

        /*{
          title: "Jobs",
          icon: "mdi-credit-card",
          key: "job",
          permission: "job",
          disabled: false,
        },
        {
          title: "Quotations",
          icon: "mdi-account-multiple",
          key: "quotation",
          permission: "quotation",
          disabled: false,
        },
        {
          title: "Invoices",
          icon: "mdi-account-multiple",
          key: "invoice",
          permission: "invoice",
          disabled: false,
        },*/
        {
          title: "History",
          icon: "mdi-account-multiple",
          key: "history",
          permission: "history",
          disabled: false,
        },
      ],
      formValid: true,
      formLoading: false,
      pageLoading: true,
      //productTab: null,
      product: 0,
    };
  },
  components: {
    DetailTemplate,
    Overview,
    ProductPriceListing,
    ProductSpplierListing,
    Warranty,
    Tickets,
    Images,
    FileTemplate,
    Quotations,
    Invoices,
    ProductAdjustment,
    InternalHistoryDetail,
  },
  methods: {
    patchProductParams(status) {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(PATCH, {
          url: "product",
          data: {
            status,
            products: [_this.product],
          },
        })
        .then(() => {
          _this.getProductDetail();
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    updateMoreAction(action) {
      const _this = this;
      switch (action) {
        case "convert_to_equipment":
          _this.convertToEquipment();
          break;
        case "duplicate":
          _this.duplicateProduct();
          break;
        case "generate_adjustment":
          _this.adjustmentProduct();
          break;
        case "mark_as_active":
          _this.patchProductParams(1);
          break;
        case "mark_as_inactive":
          _this.patchProductParams(0);
          break;
      }
    },
    convertToEquipment() {
      this.$router.push(
        this.getDefaultRoute("equipment.create", {
          query: {
            product: this.product,
          },
        })
      );
    },
    duplicateProduct() {
      this.$router.push(
        this.getDefaultRoute("product.create", {
          query: {
            duplicate: this.product,
          },
        })
      );
    },
    adjustmentProduct() {
      // alert(23);
      console.log(this.product, "hello");
      this.$router.push(
        this.getDefaultRoute("adjustment.create", {
          query: {
            generate_adjustment: this.product,
            product_type: "goods",
          },
        })
      );
    },
    getProductDetail() {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(GET, {
          url: "product/adjustment/" + _this.product,
        })
        .then(({ data }) => {
          _this.detail = data;
          //console.log(_this.detail,"_this.detail");
          _this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Adjustment", route: "adjustment" },
            { title: "Detail" },
            { barcode: data.barcode },
          ]);
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
  },
  mounted() {
    const _this = this;
    _this.getProductDetail();
    this.productTab = "adjustment";

    _this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Product", route: "product" },
      { title: "Detail" },
    ]);
  },
  created() {
    const _this = this;
    _this.product = _this.$route.params.id;
    if (!_this.product || _this.product <= 0) {
      _this.$router.go(-1);
    }

    if (_this.$route.query && _this.$route.query.tab) {
      _this.productTab = _this.$route.query.tab;
    }
  },
  computed: {
    productTab: {
      set(val) {
        let query = { ...this.$route.query };
        query.tab = val;
        if (this.productTab != val) {
          this.$router.push({ query });
        }
      },
      get() {
        return this.$route.query.tab || "adjustment";
      },
    },
  },
};
</script>
